import { createSlice } from "@reduxjs/toolkit";
import { fetchGroup } from "../actions/groupAction";
import { REHYDRATE } from "redux-persist";

const initialState = {
  data: {
    id: 0,
    name: "",
    created_user_id: 0,
    created_user_name: "",
    created_date: "",
    updated_user_id: 0,
    updated_user_name: "",
    updated_date: "",
  },
  isLoading: false,
  error: false,
};

export const groupSlice = createSlice({
  name: "group",
  initialState,
  reducers: {
    group: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGroup.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchGroup.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchGroup.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(REHYDRATE, (state) => {
      const { data } = state;
      state.isLoading = false;
      state.data = data;
    });
  },
});

export const { group } = groupSlice.actions;

export default groupSlice.reducer;
